var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 12.6011L6.39925 18.7346C6.33149 18.7797 6.25276 18.8055 6.17145 18.8094C6.09015 18.8133 6.00931 18.7951 5.93755 18.7567C5.86579 18.7182 5.80579 18.6611 5.76395 18.5913C5.72211 18.5214 5.69999 18.4416 5.69995 18.3602V5.64138C5.69999 5.55998 5.72211 5.48012 5.76395 5.4103C5.80579 5.34048 5.86579 5.28331 5.93755 5.24489C6.00931 5.20647 6.09015 5.18824 6.17145 5.19213C6.25276 5.19602 6.33149 5.22189 6.39925 5.26698L15.6 11.4005V5.70078C15.6 5.46209 15.6948 5.23317 15.8636 5.06439C16.0323 4.8956 16.2613 4.80078 16.5 4.80078C16.7386 4.80078 16.9676 4.8956 17.1363 5.06439C17.3051 5.23317 17.4 5.46209 17.4 5.70078V18.3008C17.4 18.5395 17.3051 18.7684 17.1363 18.9372C16.9676 19.106 16.7386 19.2008 16.5 19.2008C16.2613 19.2008 16.0323 19.106 15.8636 18.9372C15.6948 18.7684 15.6 18.5395 15.6 18.3008V12.6011Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkip);
export default __webpack_public_path__ + "static/media/skip.20851b02a1f666ed4de1b8c05e8208be.svg";
export { ForwardRef as ReactComponent };